import { User } from 'configcat-react';

import { useAuth } from '@/hooks/use-auth.ts';

export const useConfigCatUser = (): User | undefined => {
    const { locationIds, practiceIds, mapPractitionerId, customerIds, instanceIds } = useAuth();
    const customerId = customerIds[0];

    if (!customerId) {
        return undefined;
    }

    return new User(customerId, undefined, undefined, {
        locationIds: locationIds,
        instanceIds: instanceIds,
        practiceIds: practiceIds,
        mapPractitionerId: mapPractitionerId,
    });
};
